import React from "react";
import { FormattedMessage } from "react-intl";

import RecentPlans from "../RecentPlans";

import { StyledRecentPlans, Panel, Hero } from "./styles";
import messages from "./messages";

export default () => (
    <Hero>
        <Panel>
            <h1>
                <FormattedMessage {...messages.title} />
            </h1>
            <p>
                <FormattedMessage {...messages.p} />
            </p>
        </Panel>
        <StyledRecentPlans>
            <RecentPlans />
        </StyledRecentPlans>
    </Hero>
);
